import { Product } from '../storage'
import { CATEGORY_DEFAULT_OPTION } from '../../../util/consts'

export const getFilterCategories = (data: Product[] | undefined | null) => {
  const unique = [...new Set(data?.map((x) => x.category))].sort((a, b) => a?.localeCompare(b))
  unique.unshift(CATEGORY_DEFAULT_OPTION)
  return unique
}
